module.exports = __webpack_public_path__ + "img/laswerk3.8f57e3f8.jpg";